import { isActionOf } from 'typesafe-actions'
import { from, of } from 'rxjs'
import { catchError, exhaustMap, filter, map, switchMap } from 'rxjs/operators'
import { toast } from 'react-toastify'

import { RootEpic } from '../types'
import {
  requestIntroducerRequest,
  requestIntroducerSuccess,
  requestIntroducerFailure,
  getReferralsRequest,
  getReferralsSuccess,
  getReferralsFailure,
} from '../actions'

export const requestIntroducerEpic: RootEpic = (action$, _, { introducerRequest }) => {
  return action$.pipe(
    filter(isActionOf([requestIntroducerRequest])),
    exhaustMap(({ payload }) =>
      from(introducerRequest(payload)).pipe(
        map((response) => {
          if (response.success) toast.success('Request was sent successfully.')
          return requestIntroducerSuccess(response)
        }),
        catchError((message) => {
          toast.error('Error Apply to Introducer.')
          return of(requestIntroducerFailure(message))
        }),
      ),
    ),
  )
}

export const fetchReferralsEpic: RootEpic = (action$, _, { fetchUserReferrals }) =>
  action$.pipe(
    filter(isActionOf([getReferralsRequest])),
    switchMap(({ payload }) =>
      from(fetchUserReferrals(payload)).pipe(
        map((response) => getReferralsSuccess(response)),
        catchError((message) => {
          toast.error('Failed to fetch introducer users.')
          return of(getReferralsFailure(message))
        }),
      ),
    ),
  )

export default [requestIntroducerEpic, fetchReferralsEpic]
